<template>
  <div class="h-0 border-t border-n-weak/50 my-1" />
</template>
